export const name = 'clickHandlerRegistrar' as const
export const LinkClickHandlersProvider = Symbol('LinkClickHandlersProvider')
export const PreviewTooltipCallbackSymbol = Symbol('PreviewTooltipCallback')
export const OnLinkClick = Symbol('OnLinkClick')
